import BaseModelAPI from '../BaseModelAPI';

export default class ReportTracingAbilityBackwardList extends BaseModelAPI {

	static entity = 'newreport2134list'
	static entityName = 'reporttracingabilitybackward';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
